// Custom parameters
window.addeventasync = function() {
  addeventatc.settings({
    license: 'awuegChUvzQqNtTOzmQn45320'
  });
};